<template>
  <div class="tw-flex tw-flex-col tw-gap-1.5">
    <p
      v-for="(paragraph, i) in content"
      :key="i"
    >
      {{ paragraph }}
    </p>
  </div>
</template>


<script>
import taxTransitionMethodology from '@frontend/ui/features/tax/taxTransitionMethodology.json';

export default {
  name: 'TaxTransitionMethodology',
  data() {
    return { content: taxTransitionMethodology };
  },
};
</script>
